import { RecoilValue, RecoilValueReadOnly, selector } from 'recoil';

import { defined } from '../defined';
import { normalizeLabel } from '../normalizeLabel';

export const notEmptyValidator = (
	fieldName: string,
	valueState: RecoilValue<string | undefined>,
	key = `${normalizeLabel(fieldName)}__validation`
): RecoilValueReadOnly<string | undefined> =>
	selector({
		key,
		get({ get }) {
			const value = get(valueState);

			if (defined(value) && value !== '') return;

			return `${fieldName} is required.`;
		}
	});
